import React from 'react';
import ReviewDecisionModal from './ReviewDecisionModal';
import DocumentReview from './DocumentReview';
import { Empty } from './Feedback';

export default function ApplicationReviewModal({ application, mutation, onClose }) {
  const documents = application.documents || [];
  const missing = (application.selection.document_requirements || []).filter(requirement =>
    requirement.required && !documents.some(document => document.document_requirement_id === requirement.id));
  const blocked = missing.length > 0 || documents.some(document => document.status !== 'approved');
  return (
    <ReviewDecisionModal
      title="Analisar inscrição"
      description={application.user.name}
      mutation={mutation}
      onClose={onClose}
      reasonRequired={false}
      approvalBlocked={blocked}
      options={[
        ['approved', 'Deferir inscrição'],
        ['documents_pending', 'Solicitar documentos'],
        ['rejected', 'Indeferir inscrição'],
      ]}
    >
      <section className="portal-form-documents" aria-label="Documentos da inscrição">
        <h3>Documentos da inscrição</h3>
        {blocked && <div className="alert alert-warning" role="status">
          Para deferir a inscrição, todos os documentos enviados devem estar aprovados e nenhum documento obrigatório pode estar faltando.
        </div>}
        {missing.map(requirement => <div key={requirement.id} className="alert alert-warning">
          Documento obrigatório não enviado: <strong>{requirement.title}</strong>
        </div>)}
        {!documents.length && <Empty>Nenhum documento enviado.</Empty>}
        {documents.map(document => <DocumentReview key={document.id} inline application={application} document={document} />)}
      </section>
    </ReviewDecisionModal>
  );
}
